import naja from "naja";

/**
 * Dropdown „Historie" v drobečkové navigaci: položky se načtou až při otevření
 * (na desktopu se dropdowny otevírají najetím myši, na dotyku kliknutím).
 * Server pozná aktuální krok podle adresy v prohlížeči a vynechá ho.
 *
 * Znovu se načítá jen po jiném requestu (navigace, záložka…) – opakované najetí
 * myší by jinak posílalo stále stejný signál a LoopGuard by zablokoval všechny requesty.
 */
class NavigationHistoryExtension {
    initialize(naja) {
        this.loading = false;
        this.stale = true;

        naja.addEventListener('complete', (event) => {
            if (!event.detail.options.navigationHistory) {
                this.stale = true;
            }
        });

        $(document).on('mouseenter show.bs.dropdown', '.navigation-history', () => this.load());
    }

    load() {
        const menu = document.querySelector('[data-navigation-history-url]');
        if (!menu || this.loading || !this.stale) {
            return;
        }

        this.loading = true;
        this.stale = false;
        naja.makeRequest('GET', menu.dataset.navigationHistoryUrl, { current: window.location.href }, {
            history: false,
            // nesmí zrušit rozběhnutou navigaci
            unique: false,
            abort: false,
            triggerElement: menu,
            navigationHistory: true,
        }).catch(() => {
            this.stale = true;
        }).finally(() => {
            this.loading = false;
        });
    }
}

export default NavigationHistoryExtension;
